import dayjs, { type Dayjs } from "dayjs"
import timezone from "dayjs/plugin/timezone"
import utc from "dayjs/plugin/utc"

dayjs.extend(utc)
dayjs.extend(timezone)

// Types for Input Parameters
type DateInput = string | Date | Dayjs
type Timezone = string

function guessTimezone() {
  return dayjs.tz.guess()
}

/**
 * Converts UTC date to local time
 * @param utcDate - UTC date to convert
 * @param tz - Timezone (optional, default - user timezone)
 * @returns Date in local time
 */
function fromUTC(utcDate: DateInput, tz?: Timezone): Dayjs {
  // const timezone = tz || getTimezone()
  return dayjs.utc(utcDate).tz(tz)
}

export { fromUTC, guessTimezone }
